import {
  CLAUDE_4_5_HAIKU_DEFAULT_MODEL_CONFIG,
  CLAUDE_FABLE_5_DEFAULT_MODEL_CONFIG,
  CLAUDE_OPUS_4_8_DEFAULT_MODEL_CONFIG,
  CLAUDE_OPUS_5_DEFAULT_MODEL_CONFIG,
  CLAUDE_SONNET_4_6_DEFAULT_MODEL_CONFIG,
  CLAUDE_SONNET_5_DEFAULT_MODEL_CONFIG,
} from "@app/types/assistant/models/anthropic";
import { AUTO_MODEL_CONFIG } from "@app/types/assistant/models/auto";
import {
  DEVSTRAL2123B_MODEL_CONFIG,
  GEMMA34B_MODEL_CONFIG,
  GEMMA312B_MODEL_CONFIG,
  GEMMA327B_MODEL_CONFIG,
  GLM5_MODEL_CONFIG,
  GLM47_MODEL_CONFIG,
  GLM47FLASH_MODEL_CONFIG,
  GPTOSS20B_MODEL_CONFIG,
  GPTOSS120B_MODEL_CONFIG,
  KIMIK2P5_MODEL_CONFIG,
  KIMIK2THINKING_MODEL_CONFIG,
  MAGISTRALSMALL2509_MODEL_CONFIG,
  MINIMAXM2_MODEL_CONFIG,
  MINIMAXM2P1_MODEL_CONFIG,
  MINIMAXM2P5_MODEL_CONFIG,
  MINISTRAL33B_MODEL_CONFIG,
  MINISTRAL38B_MODEL_CONFIG,
  MINISTRAL314B_MODEL_CONFIG,
  MISTRAL7BINSTRUCT_MODEL_CONFIG,
  MISTRALLARGE2402_MODEL_CONFIG,
  MIXTRAL8X7B_MODEL_CONFIG,
  NEMOTRONNANO9BV2_MODEL_CONFIG,
  NEMOTRONNANO12BV2_MODEL_CONFIG,
  NEMOTRONNANO330B_MODEL_CONFIG,
  NEMOTRONSUPER3120B_MODEL_CONFIG,
  NOVA2LITE_MODEL_CONFIG,
  NOVALITE_MODEL_CONFIG,
  NOVAMICRO_MODEL_CONFIG,
  NOVAPRO_MODEL_CONFIG,
  QWEN3CODER30B_MODEL_CONFIG,
  QWEN3CODER480B_MODEL_CONFIG,
  QWEN3CODERNEXT_MODEL_CONFIG,
  QWEN3NEXT80B_MODEL_CONFIG,
  QWEN3VL235B_MODEL_CONFIG,
  QWEN332B_MODEL_CONFIG,
  QWEN3235BA22B_MODEL_CONFIG,
} from "@app/types/assistant/models/bedrock";
import { DEEPSEEK_CHAT_MODEL_CONFIG } from "@app/types/assistant/models/deepseek";
import {
  FIREWORKS_DEEPSEEK_V4_PRO_MODEL_CONFIG,
  FIREWORKS_GLM_5P2_MODEL_CONFIG,
  FIREWORKS_KIMI_K2P6_MODEL_CONFIG,
  FIREWORKS_KIMI_K3_MODEL_CONFIG,
} from "@app/types/assistant/models/fireworks";
import {
  GEMINI_3_1_FLASH_LITE_MODEL_CONFIG,
  GEMINI_3_1_PRO_MODEL_CONFIG,
  GEMINI_3_5_FLASH_LITE_MODEL_CONFIG,
  GEMINI_3_5_FLASH_MODEL_CONFIG,
  GEMINI_3_6_FLASH_MODEL_CONFIG,
} from "@app/types/assistant/models/google_ai_studio";
import {
  MISTRAL_CODESTRAL_MODEL_CONFIG,
  MISTRAL_LARGE_MODEL_CONFIG,
  MISTRAL_MEDIUM_3_5_MODEL_CONFIG,
  MISTRAL_SMALL_MODEL_CONFIG,
} from "@app/types/assistant/models/mistral";
import {
  GPT_5_4_MINI_MODEL_CONFIG,
  GPT_5_4_NANO_MODEL_CONFIG,
  GPT_5_6_LUNA_MODEL_CONFIG,
  GPT_5_6_SOL_MODEL_CONFIG,
  GPT_5_6_TERRA_MODEL_CONFIG,
} from "@app/types/assistant/models/openai";
import type { ModelConfig } from "@app/types/assistant/models/types";
import { GROK_4_5_MODEL_CONFIG } from "@app/types/assistant/models/xai";

export const USED_MODEL_CONFIGS: readonly ModelConfig[] = [
  GPT_5_6_SOL_MODEL_CONFIG,
  GPT_5_6_TERRA_MODEL_CONFIG,
  GPT_5_6_LUNA_MODEL_CONFIG,
  GPT_5_4_MINI_MODEL_CONFIG,
  GPT_5_4_NANO_MODEL_CONFIG,
  CLAUDE_4_5_HAIKU_DEFAULT_MODEL_CONFIG,
  CLAUDE_SONNET_5_DEFAULT_MODEL_CONFIG,
  CLAUDE_SONNET_4_6_DEFAULT_MODEL_CONFIG,
  CLAUDE_OPUS_5_DEFAULT_MODEL_CONFIG,
  CLAUDE_OPUS_4_8_DEFAULT_MODEL_CONFIG,
  CLAUDE_FABLE_5_DEFAULT_MODEL_CONFIG,
  MISTRAL_LARGE_MODEL_CONFIG,
  MISTRAL_MEDIUM_3_5_MODEL_CONFIG,
  MISTRAL_SMALL_MODEL_CONFIG,
  MISTRAL_CODESTRAL_MODEL_CONFIG,
  GEMINI_3_1_FLASH_LITE_MODEL_CONFIG,
  GEMINI_3_1_PRO_MODEL_CONFIG,
  GEMINI_3_5_FLASH_LITE_MODEL_CONFIG,
  GEMINI_3_5_FLASH_MODEL_CONFIG,
  GEMINI_3_6_FLASH_MODEL_CONFIG,
  FIREWORKS_DEEPSEEK_V4_PRO_MODEL_CONFIG,
  DEEPSEEK_CHAT_MODEL_CONFIG,
  FIREWORKS_KIMI_K2P6_MODEL_CONFIG,
  FIREWORKS_KIMI_K3_MODEL_CONFIG,
  FIREWORKS_GLM_5P2_MODEL_CONFIG,
  GROK_4_5_MODEL_CONFIG,
  NOVAPRO_MODEL_CONFIG,
  NOVALITE_MODEL_CONFIG,
  NOVAMICRO_MODEL_CONFIG,
  NOVA2LITE_MODEL_CONFIG,
  GEMMA34B_MODEL_CONFIG,
  GEMMA312B_MODEL_CONFIG,
  GEMMA327B_MODEL_CONFIG,
  MINIMAXM2_MODEL_CONFIG,
  MINIMAXM2P1_MODEL_CONFIG,
  MINIMAXM2P5_MODEL_CONFIG,
  DEVSTRAL2123B_MODEL_CONFIG,
  MAGISTRALSMALL2509_MODEL_CONFIG,
  MINISTRAL33B_MODEL_CONFIG,
  MINISTRAL38B_MODEL_CONFIG,
  MINISTRAL314B_MODEL_CONFIG,
  MISTRAL7BINSTRUCT_MODEL_CONFIG,
  MISTRALLARGE2402_MODEL_CONFIG,
  MIXTRAL8X7B_MODEL_CONFIG,
  KIMIK2THINKING_MODEL_CONFIG,
  KIMIK2P5_MODEL_CONFIG,
  NEMOTRONNANO12BV2_MODEL_CONFIG,
  NEMOTRONNANO330B_MODEL_CONFIG,
  NEMOTRONNANO9BV2_MODEL_CONFIG,
  NEMOTRONSUPER3120B_MODEL_CONFIG,
  GPTOSS120B_MODEL_CONFIG,
  GPTOSS20B_MODEL_CONFIG,
  QWEN3235BA22B_MODEL_CONFIG,
  QWEN332B_MODEL_CONFIG,
  QWEN3CODER30B_MODEL_CONFIG,
  QWEN3CODER480B_MODEL_CONFIG,
  QWEN3CODERNEXT_MODEL_CONFIG,
  QWEN3NEXT80B_MODEL_CONFIG,
  QWEN3VL235B_MODEL_CONFIG,
  GLM47_MODEL_CONFIG,
  GLM47FLASH_MODEL_CONFIG,
  GLM5_MODEL_CONFIG,
  AUTO_MODEL_CONFIG,
] as const;
